<div class="wishes-track-dialog">
  <div class="dialog-header">
    <div class="header-content">
      <h2 class="dialog-title">{{ data.dayName }}, {{ data.date }}</h2>
    </div>
    <button mat-icon-button class="close-button" (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="section" *ngIf="data.cards && data.cards.length > 0">
      <h3 class="section-title">Wishes</h3>
      <div class="cards-container">
        <div class="wish-track-card" *ngFor="let c of data.cards">
          <div class="wish-name">{{ c.wishName || 'Wish' }}</div>
          <div *ngIf="c.wishDescription" class="wish-desc">{{ c.wishDescription }}</div>
          <div *ngIf="c.actionLabel" class="action-label">{{ c.actionLabel }}</div>
          <div class="meta-row" *ngIf="c.status">
            <div class="meta-item">
              <span class="meta-label">Status</span>
              <span
                class="meta-value"
                [class.done]="(c.status || '').toLowerCase() === 'done' || (c.status || '').toLowerCase() === 'completed'"
                [class.missed]="(c.status || '').toLowerCase() === 'missed'"
                [class.pending]="(c.status || '').toLowerCase() === 'pending'">
                {{ c.status }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-data" *ngIf="!data.cards || data.cards.length === 0">
      <p>No entries found for this date.</p>
    </div>
  </div>
</div>
